import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { NAV } from "@/data/content";
import { useGoTo } from "@/lib/useGoTo";

const NavItem = ({ n, onGo, mobile }) => {
  const cls = mobile
    ? "block w-full text-left py-3 font-display text-2xl font-extrabold text-white hover:text-[#FFEF00]"
    : "text-sm font-semibold text-slate-200 hover:text-[#FFEF00] transition-colors";
  const tid = `${mobile ? "mobile-" : ""}nav-${n.label.toLowerCase()}`;
  if (n.to) return <Link to={n.to} data-testid={tid} className={cls}>{n.label}</Link>;
  return <button data-testid={tid} onClick={() => onGo(n.id)} className={cls}>{n.label}</button>;
};

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [solid, setSolid] = useState(false);
  const goTo = useGoTo();
  const { pathname } = useLocation();
  useEffect(() => {
    const on = () => setSolid(window.scrollY > 40);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => { setOpen(false); }, [pathname]);
  const go = (id) => { setOpen(false); goTo(id); };

  return (
    <header data-testid="site-header" className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${solid || open ? "bg-[#07080E]/85 backdrop-blur-xl border-b border-white/5" : ""}`}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="shrink-0">
          <img src="/brand/logo.png" alt="ZoopUp" className="h-9 md:h-10 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => <NavItem key={n.label} n={n} onGo={go} />)}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="header-book-now" onClick={() => go("book")} className="btn-zoop rounded-full px-5 py-2.5 text-sm font-bold font-display">Book Now</button>
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="lg:hidden p-2 text-white" aria-label="Menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} className="lg:hidden px-5 pb-6" data-testid="mobile-menu">
            {NAV.map((n) => <NavItem key={n.label} n={n} onGo={go} mobile />)}
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
